import MetasRepository from './Repository/MetaRepository';

const repositories = {
    meta: MetasRepository,
};

export const RepositoryFactory = {
    get: name => repositories[name]
};